import apiClient from "./apiClient";

// invoices
export const getInvoiceReport = (
  noLimit = true, 
  invoiceDateStart = "", 
  invoiceDateEnd = "",
  dueDateStart = "",
  dueDateEnd = "",
  petOwnerId = "",
  historyEntryUserId = "",
  procedureId = ""
) => apiClient
  .get("/reports/invoice", { params: { noLimit, invoiceDateStart, invoiceDateEnd, dueDateStart, dueDateEnd, petOwnerId, historyEntryUserId, procedureId } })
  .then(res => res);

export const getMedicalHistoryReport = (
  noLimit = true, 
  dateStart = "", 
  dateEnd = "",
  petId = "",
  petOwnerId = "",
  historyEntryUserId = "", 
  procedureId = ""
) => apiClient
  .get("/reports/medical-history", { params: { noLimit, dateStart, dateEnd, petId, petOwnerId, historyEntryUserId, procedureId } })
  .then(res => res);

export const getAppointmentReport = (
  noLimit = true, 
  dateStart = "", 
  dateEnd = "",
  petId = "",
  userId = "",
  statusId = "",
  remarks = ""
) => apiClient
  .get("/reports/appointment", { params: { noLimit, dateStart, dateEnd, petId, userId, statusId, remarks } })
  .then(res => res);

  export const getInventoryCurrentStock = (
    noLimit = true
  ) => apiClient
    .get("/reports/inventory-stock-levels", { params: { noLimit } })
    .then(res => res);

  export const getInventoryLowStock = (
    noLimit = true
  ) => apiClient
    .get("/reports/inventory-low-stock", { params: { noLimit } })
    .then(res => res);

  export const getInventoryExpiring = (
    noLimit = true
  ) => apiClient
    .get("/reports/inventory-expiry", { params: { noLimit } })
    .then(res => res);

  export const getInventoryTransactions = (
    noLimit = true, 
    dateStart = "", 
    dateEnd = "",
    transactionTypeId = "",
    itemCategoryId = "",
    historyEntryId = "",
    userId = "",
    supplierId = "",
  ) => apiClient
    .get("/reports/inventory-transactions", { params: { noLimit, dateStart, dateEnd, transactionTypeId, itemCategoryId, historyEntryId, userId, supplierId } })
    .then(res => res);